import type { ReactNode } from 'react';

/** Une section de réglage : texte à gauche, saisie à droite sur grand écran. */
export function SectionReglage({
  titre,
  children,
  saisie,
}: {
  titre: string;
  children: ReactNode;
  saisie: ReactNode;
}): JSX.Element {
  return (
    <section className="flex flex-col gap-4 rounded-2xl bg-white p-4 shadow-card sm:p-5 lg:flex-row lg:items-center lg:justify-between">
      <div className="min-w-0 space-y-1 lg:max-w-3xl">
        <h2 className="font-display text-base font-bold text-codialis-navy">{titre}</h2>
        {children}
      </div>
      <div className="flex shrink-0 flex-col gap-2 sm:items-end">{saisie}</div>
    </section>
  );
}
